import React from 'react';
import { FireFilled, StarFilled } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const red = '#EE3A3A';
const yellow = '#F4B336';
const green = '#519E62';
const cyan = '#2AB4C6';
const orange = '#D76718';

const qualityColors = [red, yellow, green];
const temperatureColors = [cyan, yellow, orange];

const possibleRatingValues = [1, 2, 3];
const possibleTypes = ['quality', 'temperature'];
const possibleIcons = { quality: StarFilled, temperature: FireFilled };

const StyledDiv = styled.div`
  display: flex;
  gap: 4px;
`;

const RatingIcon = ({ rating, type }) => {
  if (!possibleRatingValues.includes(rating) || !possibleTypes.includes(type)) {
    return null;
  }

  const color = type === 'quality' ? qualityColors[rating - 1] : temperatureColors[rating - 1];

  const IconToRender = ({ ...props }) => React.createElement(possibleIcons[type], { ...props });

  const AllIcons = [...Array(rating)].map((_, index) => (
    <IconToRender
      data-testid={`${type}-icon-to-render`}
      key={`rating-icon-${index}`}
      type={type}
      style={{ color, fontSize: 14 }}
    />
  ));

  return <StyledDiv>{AllIcons}</StyledDiv>;
};

RatingIcon.propTypes = {
  rating: PropTypes.oneOf([1, 2, 3]),
  type: PropTypes.oneOf(['quality', 'temperature']),
};

RatingIcon.defaultProps = {
  rating: 3,
  type: 'quality',
};

export { RatingIcon };
